import { render } from "./LockAccount.vue?vue&type=template&id=4dabe836&scoped=true"
import script from "./LockAccount.vue?vue&type=script&lang=js"
export * from "./LockAccount.vue?vue&type=script&lang=js"

import "./LockAccount.vue?vue&type=style&index=0&id=4dabe836&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dabe836"]])

export default __exports__